"use client";

import type { ReactNode, ButtonHTMLAttributes } from "react";

type Variant = "primary" | "outline";

interface LinkButtonProps {
  href: string;
  children: ReactNode;
  variant?: Variant;
  className?: string;
  produkt?: string;
  preis?: string;
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: Variant;
  className?: string;
}

const getButtonClasses = (variant: Variant, className: string = "") => {
  const base =
    "inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full font-medium transition-all " +
    "px-5 py-3 text-sm sm:px-8 sm:py-4 sm:text-base";

  const variants = {
    primary:
      "bg-brand-primary text-white border border-brand-primary hover:bg-brand-primary-dark hover:-translate-y-1 hover:shadow-xl",
    outline:
      "bg-white text-brand-primary border border-brand-primary hover:bg-slate-50 hover:-translate-y-1 hover:shadow-xl",
  };

  return `${base} ${variants[variant]} ${className}`;
};

export default function LinkButton({
  href,
  children,
  variant = "primary",
  className = "",
  produkt,
  preis,
}: LinkButtonProps) {
  const handleClick = () => {
    let url = href;

    const params = new URLSearchParams();

    if (produkt) params.append("produkt", produkt);
    if (preis) params.append("preis", preis);

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    window.location.href = url;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={getButtonClasses(variant, className)}
    >
      {children}
    </button>
  );
}

export function Button({
  children,
  variant = "primary",
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button className={getButtonClasses(variant, className)} {...props}>
      {children}
    </button>
  );
}
